@for (pinnedTimer of timerService.pinnedTimers; track trackByTimerName($index, pinnedTimer)) {
  <nx-timer
    [timer]="pinnedTimer"
    [pinned]="true"
    class="pinned-timer"
    [expansionPanelDisabled]="true"
  ></nx-timer>
}
